import React from 'react'
import { Nav, Navbar } from 'react-bootstrap';
import './navbar.css'
import logo from '../../assets/images/logoAIDay_Plan de travail 1.png'
import Particles from 'react-particles-js';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt, faCalendarCheck } from '@fortawesome/free-solid-svg-icons'
import DescriptionContent from '../descriptionContent';
import Gallery from '../gallery';
import Trainer from '../trainer'
import FAQ from '../faq';
import Follow from '../follow';
import AgendaHeader from '../agendaHeader';
import Talks from '../talks';

import { HashLink } from 'react-router-hash-link';
export default function WebNavbar() {
    return (
        <>
            <div className="App">
                <section id="home">
                    <Particles className="particlesJS"
                        params={{
                            particles: {
                                color: {
                                    value: "#ffffff"
                                },
                                line_linked: {
                                    color: {
                                        value: "#FFFFFF"
                                    },
                                    enable: true,
                                    distance: 150,

                                    opacity: 0.4,
                                    width: 1
                                },
                                number: {
                                    value: 60,
                                    density: {
                                        enable: true,
                                        value_area: 800
                                    }
                                },
                                size: {
                                    value: 3,
                                    random: true,
                                    anim: {
                                        enable: false,
                                        speed: 40,
                                        size_min: 0.1,
                                        sync: false
                                    }
                                },
                                shape: {
                                    type: "circle",
                                    stroke: {
                                        width: 0,
                                        color: "#000000"
                                    },
                                    polygon: {
                                        nb_sides: 5
                                    },

                                },
                                opacity: {
                                    value: 0.5,
                                    random: false,
                                    anim: {
                                        enable: false,
                                        speed: 1,
                                        opacity_min: 0.1,
                                        sync: false
                                    }
                                },
                                move: {
                                    enable: true,
                                    speed: 3,
                                    direction: "none",
                                    random: false,
                                    straight: false,
                                    out_mode: "out",
                                    bounce: false,
                                    attract: {
                                        enable: false,
                                        rotateX: 600,
                                        rotateY: 1200
                                    }
                                }
                            }, retina_detect: true
                        }}
                    />
                </section>

                <div className="def-container">
                    <DescriptionContent />
                    <Gallery />
                    <Trainer />
                    <Talks />
                 {/*  <AgendaHeader />*/} 
                    <FAQ />
                    <Follow />
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3198.729639869486!2d3.171726914924375!3d36.705034180751404!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x128e522f3f317461%3A0x215c157a5406653c!2sEcole%20Nationale%20Sup%C3%A9rieure%20d&#39;Informatique!5e0!3m2!1sfr!2sdz!4v1610042223994!5m2!1sfr!2sdz" width="99.9%" height="500" frameBorder="0" style={{ border: "solid 6px #DB4E50", marginBottom: "-8px" }} allowFullScreen="" aria-hidden="false" tabIndex="0" title="address"></iframe>
                </div>

                <Card elevation={0} className="register-container">
                    <CardContent className="card-content-container">
                        <h1 className="home-title">AI DAY</h1>
                        <h3 className="home-subtitle">One day, a lot of knowledge</h3>
                        <div className="icons-container">

                            <FontAwesomeIcon className="home-icon" icon={faCalendarCheck} /> <div className="home-icon-container"> Saturday, 6th Februray 2021</div><br></br>
                            <FontAwesomeIcon icon={faMapMarkerAlt} className="home-icon" id="second-icon" />   <div className="home-icon-container" id="second-icon-container"> Online Event</div>
                        </div>
                        <div class="arrows-container">
                            <div class="arrow-container"><a href="#" class="arrow up">Up</a> </div>

                            <div className="register-btn-container">
                                <HashLink to="/agenda" className="register-btn  button" data-mode="popup"

                                    data-size="100">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                 AGENDA !
                                    </HashLink>


                            </div>
                            <div class="arrow-container">   <a href="#" class="arrow down">Down</a> </div>

                            <script>
                                {(function () {
                                    var js, q, d = document, gi = d.getElementById,
                                        ce = d.createElement, gt = d.getElementsByTagName,
                                        id = "typef_orm_share", b = "https://embed.typeform.com/";
                                    if (!gi.call(d, id)) {
                                        js = ce.call(d, "script");
                                        js.id = id;
                                        js.src = b + "embed.js";
                                        q = gt.call(d, "script")[0];
                                        q.parentNode.insertBefore(js, q)
                                    }
                                })()}
                            </script>
                        </div>
                    </CardContent>
                </Card>




            </div>
            <Navbar fixed="top" expand="lg" className="nav">
                <Navbar.Brand className="logo" href="#home"><img alt="AI DAY logo" className="logo_img" src={logo} /></Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mr-auto">
                        <HashLink className="main_list_item" to="/#home">Home</HashLink>

                        <HashLink className="main_list_item" to="/#link">About</HashLink>

                        <HashLink className="main_list_item" to="/#Gallery">Gallery</HashLink>

                        {<HashLink className="main_list_item" to="/agenda">
                            Agenda
                        </HashLink>
                        }
                        <HashLink className="main_list_item" to="/#Trainers">Trainers</HashLink>

                        <HashLink className="main_list_item" to="/#FAQ">faq</HashLink>

                        <HashLink className="main_list_item" to="/#Follow Us">Follow Us</HashLink>

                    </Nav>

                </Navbar.Collapse>
            </Navbar>
        </>
    )
}